export interface Presenter {
  value: any
  style: 'camel' | 'snake'
  whiteList?: string[]
}

export const presenter = <T = any>({
  value,
  style,
  whiteList = []
}: Presenter): T => {
  return serialize({ value, style, whiteList })
}

const serialize = ({ value, style, whiteList }: Presenter): any => {
  if (!style || value === null) {
    return value
  }

  const type = typeof value
  if (type === 'object') {
    //  No trae propiedades []
    if (!Object.keys(value)?.length) {
      return value
    }

    //  Se trata de un array
    if (Array.isArray(value)) {
      return capitalizeArray({ value, style, whiteList })
    }
    //  Es un objeto con propiedades
    return capitalizeObject({ value, style, whiteList })
  }

  return value
}

const capitalizeArray = ({ value: values, style, whiteList }: Presenter) => {
  const codes = []
  for (const current of values) {
    if (whiteList && whiteList.includes(current)) {
      continue
    }
    codes.push(serialize({ value: current, style }))
  }
  return codes
}

const capitalizeObject = ({ value, style, whiteList }: Presenter) => {
  const codes: any = {}

  // Obtenemos las key's del objeto
  const keys = Object.keys(value)

  // Recorremos cada key (string)
  for (const key of keys) {
    if (whiteList && whiteList.includes(key)) {
      continue
    }

    let codeCase: string
    // Se procesa cada palabra del array split
    switch (style) {
      case 'camel': {
        codeCase = camelCase(key)
        break
      }
      case 'snake': {
        codeCase = snakeCase(key)
      }
    }

    // Se va generando el nuevo objeto
    codes[codeCase] = serialize({ value: value[key], style })
  }
  return codes
}

const camelCase = (key: string) => {
  // Separamos el string por un '_'
  const split = key.split(/_|-|(?=[A-Z])/)
  const filter = split.filter((token) => token !== '')

  let isOnlyLetter = false
  // Se procesa cada palabra del split array
  let codeCase = filter
    .map((token, index) => {
      let word = token

      // No es la primera palabra, [0]
      if (index > 0) {
        let parse: string
        // La primera letra del string va en mayúscula si la palabra anterior no fue de una sola letra (mayúscula)
        if (isOnlyLetter) {
          parse = word.charAt(0).toLowerCase()
        } else {
          parse = word.charAt(0).toUpperCase()
        }

        // Si la palabra tiene más de una letra
        if (word.length > 1) {
          // Se concatena la primera letra en procesada y el resto de la palabra en minúscula
          word = parse + word.slice(1).toLowerCase()
          isOnlyLetter = false
        } else {
          word = parse
          isOnlyLetter = true
        }
      } else {
        // Es la primera palabra y únicamente se asegura de retornarla en miniscula [0]
        word = word.toString().toLowerCase()
      }

      return word
    })
    .join('')

  const isSpecial = split[0] === ''
  // Tine '_' al iniciar, se trata de un caso especial
  if (isSpecial) {
    const privateCodes: string[] = split.reduce(
      (acc: string[], next: string) => {
        if (next === '') {
          acc.push('_')
        }
        return acc
      },
      []
    )
    codeCase = `${privateCodes.join('')}${codeCase}`
  }
  return codeCase
}

const snakeCase = (key: string) => {
  // Separamos el string por mayúsculas, y por un '_', si se da el caso
  const split = key.split(/(?=[A-Z])|_/)
  const codeCase = split.join('_').toLowerCase()
  return codeCase
}
